import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import EpiContext from '@episerver/spa-core/Spa';
import {
  setProcessCheckpoint,
  startTroubleshootingWizard,
  } from "app/Components/Block/AbroadTroubleshootingWizardBlock/TroubleshootingWizardSlice";
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import WhatsappIcon from "app/Components/Block/AbroadTroubleshootingWizardBlock/Images/whatsApp.svg";
import AlertIcon from "app/Components/Block/AbroadTroubleshootingWizardBlock/Images/alert.svg";
import FinancialErrorIcon from "app/Components/Block/AbroadTroubleshootingWizardBlock/Images/creditcard.svg";
import NoticeIcon from "app/Components/Block/AbroadTroubleshootingWizardBlock/Images/notice.svg";
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {navigateToUrl,buildUrlOpenPageSelfAndRestBlank} from 'app/utilities/StringHelpers/StringHelpers';
import Config from "app/Config";
import {
  dwhAbroadWizardButtonClicked,
  dwhAbroadWizardAllChecksFinished,
  dwhAbroadWizardFinishedWithError
} from 'app/Components/Block/AbroadTroubleshootingWizardBlock/Reports/dwhReports';
import {ErrorsEnum} from "app/Components/Block/AbroadTroubleshootingWizardBlock/Enums/ErrorsEnum";
import {extractContentData} from "app/Components/Block/AbroadTroubleshootingWizardBlock/Utils/ContentDataUtils";
import {
    TroubleshootingWizardProcess
} from "app/Components/Block/AbroadTroubleshootingWizardBlock/Enums/TroubleshootingWizardProcess";
import { setSelfcareSubscriber } from "app/Components/Page/SelfCarePage/SelfCareSlice";


export const ErrorContent = (props) => {
  const {errorReason, selectedSubscriber, process} = props.TroubleshootingWizardSlice;
  const epiContent = extractContentData(props.contentData);
  const cellularSubscribers = props.selfcareData?.subscribersByProduct?.cellular || [];
  const isPrivate = !cellularSubscribers.find((sub) => sub.productSubscriberNo === selectedSubscriber)?.isBusiness;
  const whatsAppContactLink = epiContent?.whatsAppNumber ? `https://wa.me/${epiContent.whatsAppNumber}` : null;

  const handleWhatsAppClick = () => {
    if(whatsAppContactLink) {
      document.location.href = whatsAppContactLink;
    }
  }

  const createLinkAction = (text, onClick, index = "default", dispatchSubscriber = false) => (
    text && (
      <span
        key={index}
        className='link-action'
        onClick={() => {
          dwhAbroadWizardButtonClicked({ param1: text, process });
          if (dispatchSubscriber) {
            EpiContext.getStore().dispatch(setSelfcareSubscriber(selectedSubscriber));
          }
          onClick();
        }}
      >
        {text}
      </span>
    )
  );

  const createWhatsAppAction = (onClick) => (
    <div className={'action-container'}>
      <span className={'description'}>נשמח לסייע לך</span>
      <BtnWhiteBlackBorderBigSize
        text={
          <>
            <Image src={WhatsappIcon} alt="WhatsApp" className={'whatsapp-icon'} /> לנציג ב-WhatsApp
          </>
        }
        onclick={() => {
          dwhAbroadWizardButtonClicked({ param1: 'לנציג ב-WhatsApp', process });
          onClick();
        }}
      />
    </div>
  );

  const createCallBackAction = (text, onClick) => (
    <div className={'action-container'}>
      <span className={'description'}>נשמח לסייע לך</span>
      <BtnWhiteBlackBorderBigSize text={text} onclick={onClick} />
    </div>
  );

  const getServiceAction = () => {
    if (process === TroubleshootingWizardProcess.AbroadData || process === TroubleshootingWizardProcess.AbroadCellular) {
      return createWhatsAppAction(() => handleWhatsAppClick());
    } else {
      return createCallBackAction('תתקשרו אלי', () => console.log('Callback requested'));
    }
  };

  const errorContentMap = {
    // SUBSCRIBER ISSUES
    [ErrorsEnum.SUBSCRIBER_IS_NOT_ABROAD]: {
      icon: AlertIcon,
      title: 'זיהינו שהמנוי נמצא בארץ',
      subtitle: 'האשף מיועד רק למנויים הנמצאים בחו"ל ולא ניתן לבצע את הבדיקות על מנוי שנמצא בארץ',
      action: createLinkAction(epiContent.localCellularTechnicalLobbyLinkText, () =>
        buildUrlOpenPageSelfAndRestBlank(epiContent.localCellularTechnicalLobbyLink),
      ),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.NO_CELLULAR_SUBSCRIBER]: {
      icon: AlertIcon,
      title: (
        <>
          אנחנו לא מזהים שיש לך
          <br />
          מנוי סלולר ב{window.Config.brand_Name_HE}
        </>
      ),
      subtitle: (
        <>
          יכול להיות שנרשמתם עם פרטים אחרים?
          <br />
          שווה לנסות להתחבר שוב
        </>
      ),
      action: createLinkAction(epiContent.joinServiceLinkText, () => buildUrlOpenPageSelfAndRestBlank(Config.joinCellularServiceLink)),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.BUSINESS_SUBSCRIBER]: {
      icon: AlertIcon,
      title: (
        <>
          מנוי {selectedSubscriber} הינו עיסקי
          <br />
          יש לפנות לאיש הקשר בארגונך
          <br />
          למתן שירות
        </>
      ),
      subtitle: null,
      action: null,
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.KOSHER_SUBSCRIBER]: {
      icon: AlertIcon,
      title: (
        <>
          זיהינו שהמנוי כשר
          <br />
          ולכן לא יכול לגלוש
        </>
      ),
      subtitle: null,
      action: null,
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.DATA_ONLY]: {
      icon: AlertIcon,
      title: (
        <>
          מנוי זה מיועד לדאטה בלבד
          <br />
          ולכן שיחות והודעות לא נתמכות
        </>
      ),
      subtitle: null,
      action: null,
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.DEFENSE_POLICY_BLOCKED]: {
      icon: AlertIcon,
      title: (
        <>
          הקו חסום בהתאם להנחיית
          <br />
          משרד התקשורת
        </>
      ),
      subtitle: 'לפרטים נוספים ניתן לפנות למשרד התקשורת',
      action: null,
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },

    // ROAMING ISSUES
    [ErrorsEnum.ROAMING_BLOCKED]: {
      icon: AlertIcon,
      title: (
        <>
          נראה שהקו {selectedSubscriber}
          <br />
          חסום לנדידה בחו"ל
        </>
      ),
      subtitle: null,
      action: createWhatsAppAction(() => handleWhatsAppClick()),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.AMDOCS_ROAMING_BLOCKED]: {
      icon: AlertIcon,
      title: 'נראה שהקו חסום לנדידה בחו"ל',
      subtitle: (
        <>
          כדי להשתמש בשירותים בחו"ל
          <br />
          יש לרכוש חבילה מתאימה
        </>
      ),
      action: createLinkAction(epiContent.abroadLobbyLinkText, () => {
        EpiContext.getStore().dispatch(setSelfcareSubscriber(selectedSubscriber));
        navigateToUrl(isPrivate ? epiContent.privateAbroadLobbyLink : epiContent.businessAbroadLobbyLink);
      }, "default", true),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.AMDOCS_ROAMING_BLOCKED_CALLS]: {
      icon: AlertIcon,
      title: 'נראה שהקו חסום לנדידה בחו"ל',
      subtitle: (
        <>
          כדי להשתמש בשירותים בחו"ל
          <br />
          יש לרכוש חבילה מתאימה
        </>
      ),
      purpleInnerDiv: {
        icon: NoticeIcon,
        title: (
          <>
            שיחות בחו"ל ללא חבילה כרוכות בחיוב
            <br />
            בסכומים גבוהים
          </>
        ),
        actions: [
          {
            actionFunc: createLinkAction,
            text: epiContent.abroadLobbyLinkText,
            callback: () => {
              EpiContext.getStore().dispatch(setSelfcareSubscriber(selectedSubscriber));
              buildUrlOpenPageSelfAndRestBlank(
                isPrivate ? epiContent.privateAbroadLobbyLink : epiContent.businessAbroadLobbyLink
              );
            },
          },
          {
            actionFunc: createLinkAction,
            text: epiContent.usageCostWithoutPackageLinkText,
            callback: () => buildUrlOpenPageSelfAndRestBlank(epiContent.usageCostWithoutPackageLink),
          },
          {
            actionFunc: createLinkAction,
            text: epiContent.abroadCallsRepresentativeLinkText,
            callback: () => handleWhatsAppClick(),
          },
        ],
      },
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.EGYPT_AND_JORDAN_BLOCKED__CALL_SERVICE]: {
      icon: AlertIcon,
      title: <>הקו חסום למצרים וירדן</>,
      subtitle: 'כדי להסיר את החסימה יש לפנות לנציג',
      action: createWhatsAppAction(() => handleWhatsAppClick()),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.EGYPT_AND_JORDAN_BLOCKED__BUY_PACKAGE]: {
      icon: AlertIcon,
      title: <>נראה שהקו חסום לנדידה בחו״ל</>,
      subtitle: <>כדי להשתמש בשירותים בחו"ל
        <br />
        יש לרכוש חבילה מתאימה</>,
      action: createLinkAction(epiContent.abroadLobbyLinkText, () => {
        EpiContext.getStore().dispatch(setSelfcareSubscriber(selectedSubscriber));
        navigateToUrl(isPrivate ? epiContent.privateAbroadLobbyLink : epiContent.businessAbroadLobbyLink);
      }, "default", true),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    // SERVICE ISSUES
    [ErrorsEnum.NO_SERVICE]: {
      icon: AlertIcon,
      title: 'הקו לא מחובר לרשת סלולרית',
      subtitle: (
        <>
          כדי להתקדם יש לעקוב אחר ההנחיות
          <br />
          המופיעות במדריך
        </>
      ),
      action: createLinkAction(epiContent.operatorSelectionGuideLinkText, () => buildUrlOpenPageSelfAndRestBlank(epiContent.operatorSelectionGuideLink)),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.CELLULAR_DATA_OFF]: {
      icon: AlertIcon,
      title: `מנוי ${selectedSubscriber} חסום לגלישה`,
      subtitle: 'האם ברצונך לפתוח את החסימה?',
      action: createLinkAction(epiContent.kidsControlLinkText, () => buildUrlOpenPageSelfAndRestBlank(epiContent.kidsControlLink)),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.NO_DATA_AND_ROAMING]: {
      icon: AlertIcon,
      title: <>נתונים ניידים + נדידת נתונים אינם פעילים במכשיר</>,
      subtitle: <>��ומלץ כעת להמשיך למדריך ולבצע את ההגדרות הרלוונטיות אצלך</>,
      action: createLinkAction('למעבר למדריך', () => buildUrlOpenPageSelfAndRestBlank(epiContent.smartWizardLink)),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.CALL_FORWARDING_PREVENTS_RECEIVING_CALLS]: {
      icon: AlertIcon,
      title: (
        <>
          בקו {selectedSubscriber} מוגדרת
          <br />
          הפניית שיחות
        </>
      ),
      subtitle: 'יש לפנות לתמיכה להמשך קבלת עזרה',
      action: createWhatsAppAction(() => handleWhatsAppClick()),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.CANT_FIND_ISSUE_WITH_LINE_SETTINGS]: {
      icon: AlertIcon,
      title: (
        <>
          סיימנו את הבדיקות
          <br />
          ולא מצאנו בעיות בקו
        </>
      ),
      subtitle: (
        <>
          כעת, כדי לבדוק שגם הגדרות המכשיר תקינות
          <br />
          מומלץ להמשיך למדריך
        </>
      ),
      action: createLinkAction('למעבר למדריך', () => buildUrlOpenPageSelfAndRestBlank(epiContent.smartWizardLink)),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },

    // PACKAGE ISSUES
    [ErrorsEnum.NO_ABROAD_PACKAGE]: {
      icon: AlertIcon,
      title: (
        <>
          במנוי {selectedSubscriber} לא קיימת
          <br />
          חבילה לחו"ל
        </>
      ),
      subtitle: <>לא ניתן לגלוש בחו"ל ללא חבילה</>,
      action: createLinkAction(epiContent.abroadLobbyLinkText, () => {
        EpiContext.getStore().dispatch(setSelfcareSubscriber(selectedSubscriber));
        navigateToUrl(isPrivate ? epiContent.privateAbroadLobbyLink : epiContent.businessAbroadLobbyLink);
      }, "default", true),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.NO_CELLULAR_PACKAGE]: {
      icon: AlertIcon,
      title: (
        <>
          חבילת חו"ל במנוי {selectedSubscriber}
          <br />
          לא כוללת גלישה
        </>
      ),
      subtitle: <>לא ניתן לגלוש בחו"ל ללא חבילה</>,
      action: createLinkAction(epiContent.purchaseContinuationLinkText, () => {
        EpiContext.getStore().dispatch(setSelfcareSubscriber(selectedSubscriber));
        navigateToUrl(isPrivate ? epiContent.purchasePrivateContinuationPackagesLink : epiContent.purchasePrivateContinuationPackagesLink);

      }, "default", true),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.EXPIRED_PACKAGE]: {
      icon: AlertIcon,
      title: `החבילה במנוי ${selectedSubscriber} הסתיימה`,
      subtitle: (
        <>
          כדי להמשיך להשתמש בשירותים בחו"ל
          <br />
          יש לרכוש חבילה חדשה
        </>
      ),
      action: createLinkAction(epiContent.purchaseContinuationLinkText, () =>
        navigateToUrl(isPrivate ? epiContent.purchasePrivateContinuationPackagesLink : epiContent.purchaseBusinessContinuationPackagesLink)
      ),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.INCOMPATIBLE_PACKAGE]: {
      icon: AlertIcon,
      title: (
        <>
          חבילת חו"ל במנוי {selectedSubscriber}
          <br />
          לא מתאימה ליעד
        </>
      ),
      subtitle: <span className={'description'}>נשמח לסייע לך ברכישת חבילה מתאימה</span>,
      action: createWhatsAppAction(() => handleWhatsAppClick()),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.ABROAD_PACKAGE_WITHOUT_CALLS]: {
      icon: AlertIcon,
      title: <>למנוי לא קיימת חבילת שיחות לחו"ל</>,
      purpleInnerDiv: {
        icon: NoticeIcon,
        title: (
          <>
            שיחות בחו"ל ללא חבילה כרוכות בחיוב
            <br />
            בסכומים גבוהים
          </>
        ),
        actions: [
          {
            actionFunc: createLinkAction,
            text: 'לרכישת חבילת שיחות לחו"ל',
            callback: () =>
              buildUrlOpenPageSelfAndRestBlank(
                isPrivate ? epiContent.purchasePrivateContinuationPackagesLink : epiContent.purchaseBusinessContinuationPackagesLink,
              ),
          },
          {
            actionFunc: createLinkAction,
            text: epiContent.usageCostWithoutPackageLinkText,
            callback: () => buildUrlOpenPageSelfAndRestBlank(epiContent.usageCostWithoutPackageLink),
          },
        ],
      },
      finishButton: (
        <BtnSubmit
          text={'ידוע, בואו נתקדם'}
          onclick={async () => {
            EpiContext.getStore().dispatch(setProcessCheckpoint('AfterEffAbroadPackageCheck'));
            await EpiContext.getStore().dispatch(startTroubleshootingWizard());
          }}
        />
      ),
    },
    [ErrorsEnum.ABROAD_PACKAGE_DOES_NOT_FIT_TO_DESTINATION]: {
      icon: AlertIcon,
      title: <>חבילת חו"ל שלך לא מתאימה ליעד</>,
      purpleInnerDiv: {
        icon: NoticeIcon,
        title: (
          <>
            שיחות בחו"ל ללא חבילה כרוכות בחיוב
            <br />
            בסכומים גבוהים
          </>
        ),
        actions: [
          {
            actionFunc: createLinkAction,
            text: epiContent.usageCostWithoutPackageLinkText,
            callback: () => buildUrlOpenPageSelfAndRestBlank(epiContent.usageCostWithoutPackageLink),
          },
        ],
      },
      action: createWhatsAppAction(() => handleWhatsAppClick()),
      finishButton: (
        <BtnSubmit
          text={'ידוע, בואו נתקדם'}
          onclick={async () => {
            EpiContext.getStore().dispatch(setProcessCheckpoint('AfterEffAbroadPackageCheck'));
            await EpiContext.getStore().dispatch(startTroubleshootingWizard());
          }}
        />
      ),
    },

    // FINANCIAL ISSUES
    [ErrorsEnum.FINANCIAL_DEBT_ERROR]: {
      icon: FinancialErrorIcon,
      title: (
        <>
          לפני שנמשיך בתהליך
          <br />
          יש לשלם את החוב בחשבון
        </>
      ),
      action: createLinkAction(epiContent.debtPaymentLinkText, () => buildUrlOpenPageSelfAndRestBlank(Config.payDebtLink)
      ),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.FINANCIAL_PAYMENT_UPDATE_ERROR]: {
      icon: FinancialErrorIcon,
      title: (
        <>
          לפני שנמשיך בתהליך
          <br />
          יש לשלם את החוב בחשבון
          <br />
          ולעדכן אמצעי תשלום
        </>
      ),
      action: (
        <div className={"action-container action-links-container"}>
          {createLinkAction(
            epiContent.debtPaymentLinkText,
            () => buildUrlOpenPageSelfAndRestBlank(Config.payDebtLink)
          )}
          {createLinkAction(
            epiContent.paymentMethodUpdateLinkText,
            () => buildUrlOpenPageSelfAndRestBlank(Config.updatePaymentMethodLink)
          )}
        </div>
      ),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.FINANCIAL_PAYMENT_METHOD_UPDATE_ERROR]: {
      icon: FinancialErrorIcon,
      title: (
        <>
          לפני שנמשיך בתהליך
          <br />
          יש לעדכן אמצעי תשלום ב{window.Config.brand_Name_HE}
        </>
      ),
      action: createLinkAction('לעדכון אמצעי תשלום', () => buildUrlOpenPageSelfAndRestBlank(epiContent.updatePaymentMethodLink)),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },

    // SUSPENDED SUBSCRIBER ISSUES
    [ErrorsEnum.SUSPENDED_SUBSCRIBER_LOST_OR_STOLEN]: {
      icon: AlertIcon,
      title: (
        <>
          מנוי {selectedSubscriber} מושהה בעקבות
          <br />
          דיווח על אובדן או גניבה
        </>
      ),
      subtitle: (
        <>
          לא ניתן לבצע פעולות בסטטוס מושהה
          <br />
          לפרטים נוספים יש לפנות לנציג שירות
        </>
      ),
      action: getServiceAction(process),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.SUSPENDED_SUBSCRIBER]: {
      icon: AlertIcon,
      title: <>מנוי {selectedSubscriber} מושהה</>,
      subtitle: (
        <>
          לא ניתן לבצע פעולות בסטטוס מושהה
          <br />
          לפרטים נוספים יש לפנות לנציג שירות
        </>
      ),
      action: getServiceAction(process),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.CONTINUE_TO_REPRESENTATIVE]: {
      icon: AlertIcon,
      title: <>מנוי {selectedSubscriber} מושהה</>,
      subtitle: <>לא ניתן לבצע פעולות בסטטוס מושהה, לפרטים נוספים יש לפנות לנציג שירות</>,
      action: getServiceAction(process),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },

    // CALLBACK ISSUES
    [ErrorsEnum.CALLBACK_ALREADY_SCHEDULED]: {
      icon: AlertIcon,
      title: 'ראינו שכבר מתואמת שיחה חזרה אליך',
      subtitle: 'נציג יחזור אליך בהקדם להמשך טיפול',
      action: null,
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    // GENERAL ERRORS
    [ErrorsEnum.GENERAL_ERROR]: {
      icon: AlertIcon,
      title: <>משהו השתבש ולא ניתן כרגע לבצע את הפעולה, אפשר לנסות שוב מאוחר יותר</>,
      subtitle: null,
      action: getServiceAction(process),
      finishButton: (
        <BtnWhiteBlackBorderBigSize
          text={'לאיזור האישי'}
          onclick={() => {
            navigateToUrl(Config.lobbyUrl);
          }}
        />
      ),
    },

    [ErrorsEnum.UNRESOLVED_ISSUE]: {
      icon: AlertIcon,
      title: <>אז נמשיך עם נציג</>,
      subtitle: null,
      action: createWhatsAppAction(() => handleWhatsAppClick()),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.CANT_RESOLVE_ISSUE]: {
      icon: AlertIcon,
      title: (
        <>
          נסינו לפתור את הבעיה
          <br />
          אבל נצטרך להמשיך עם נציג
        </>
      ),
      subtitle: null,
      action: createWhatsAppAction(() => handleWhatsAppClick()),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [ErrorsEnum.UPDATE_FAILED]: {
      icon: AlertIcon,
      title: (
        <>
          נסינו לפתור את הבעיה ומשהו
          <br />
          השתבש, יש להמשיך לנציג
        </>
      ),
      subtitle: null,
      action: createWhatsAppAction(() => handleWhatsAppClick()),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    // DEFAULT
    default: {
      icon: AlertIcon,
      title: <>משהו השתבש ולא ניתן כרגע לבצע את הפעולה, אפשר לנסות שוב מאוחר יותר</>,
      subtitle: null,
      action: getServiceAction(process),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },

  };

  const dhwObj = {
    process: process,
    param1: ErrorsEnum[errorReason] ? `Display Type: ${ErrorsEnum[errorReason]}` : '',
  };

  errorReason === ErrorsEnum.GENERAL_ERROR
  ? dwhAbroadWizardFinishedWithError(dhwObj)
  : dwhAbroadWizardAllChecksFinished(dhwObj);

  return errorContentMap[errorReason] || errorContentMap.default;
};
